import {
  faPencilAlt,
  faTimesCircle,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getCreditCards, profilePostAction } from "../../actions/profileAction";
import ConfirmDialog from "../../components/ConfirmDialog";
import { getUserDetail } from "../../utils/helper";
import CardPopup from "./CardPopup";
const CardListPopup = ({ setActiveCard, closePopup, activeCard }) => {
  const dispatch = useDispatch();
  const cardList = useSelector((state) => state.profile.cardList);
  const [selectedCard, setSelectedCard] = useState(activeCard);
  const [editCard, setEditCard] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showEditConfirmDialog, setShowEditConfirmDialog] = useState(false);
  const [showCardModal, setShowCardModal] = useState(false);
  const [listChanged, setListchanged] = useState(false);
  const handleCardChange = (e) => {
    setSelectedCard(cardList.filter((x) => x.cc_id == e.target.value)[0]);
  };
  const handleEditCard = (id) => {
    let Card = cardList.filter((x) => x.cc_id == id)[0];
    setEditCard(Card);
    if (Card?.isSubscription) {
      setShowEditConfirmDialog(true);
    } else {
      setShowCardModal(true);
    }
  };

  const handleDeleteCard = (id) => {
    let Card = cardList.filter((x) => x.cc_id == id)[0];
    setEditCard(Card);
    setShowConfirmDialog(true);
  };
  const deleteCard = () => {
    var params = {
      params: {
        action: "userDeleteCreditCard",
        data: { cc_id: editCard.cc_id },
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(params, () => {
        if (activeCard.cc_id == editCard.cc_id) {
          setActiveCard(null);
        }
        dispatch(
          getCreditCards(() => {
            setListchanged(true);
          })
        );
      })
    );
  };
  useEffect(() => {
    if (listChanged) {
      if (!cardList.some((x) => x.cc_id == activeCard?.cc_id)) {
        setActiveCard(cardList[0]);
      }
      setSelectedCard(cardList[0]);
      setListchanged(false);
    }
  }, [listChanged]);

  const creditCards = cardList.map((x) => (
    <div key={x.cc_id} className="address-item">
      <div className="labels">
        <input
          type="radio"
          name="address"
          value={x.cc_id}
          id={x.cc_id}
          onChange={handleCardChange}
          checked={selectedCard?.cc_id == x.cc_id}
        />
        <label htmlFor={x.cc_id}>{x.name}</label>
      </div>
      <div className="actions">
        <FontAwesomeIcon
          icon={faPencilAlt}
          color="#00a65a"
          onClick={() => handleEditCard(x.cc_id)}
        />
        <FontAwesomeIcon
          icon={faTrashAlt}
          color="#dd4b39"
          onClick={() => handleDeleteCard(x.cc_id)}
        />
      </div>
    </div>
  ));
  return (
    <Modal size="lg" show={true} backdrop="static">
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Choose Card</h5>
          <div className="close-btn">
            <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
          </div>
        </div>
      </Modal.Header>{" "}
      {showCardModal && (
        <CardPopup
          setListChanged={setListchanged}
          cardInfo={editCard}
          closePopup={() => setShowCardModal(false)}
        />
      )}
      {cardList?.length > 0 && (
        <Modal.Body>
          <>
            {showConfirmDialog && (
              <ConfirmDialog
                title="Are you sure want to delete this credit card?"
                acceptAction={deleteCard}
                acceptText="yes"
                rejectText="no"
                closePopup={() => setShowConfirmDialog(false)}
                note={
                  editCard?.isSubscription
                    ? "Note, this Credit Card is currently being used for your subscription. You will need to update your subscription payment address for it to renew after the current period."
                    : null
                }
              />
            )}
            {showEditConfirmDialog && (
              <ConfirmDialog
                title="Are you sure want to edit this credit card?"
                acceptAction={() => setShowCardModal(true)}
                acceptText="yes"
                rejectText="no"
                closePopup={() => {
                  setShowEditConfirmDialog(false);
                }}
              />
            )}
            {creditCards}
          </>
        </Modal.Body>
      )}
      <div className="address-submit-section ">
        {cardList?.length > 0 && (
          <button
            className="btn-orange mr-4"
            onClick={() => {
              setActiveCard(selectedCard);
              closePopup();
            }}
          >
            Select
          </button>
        )}
        <button
          className="btn-orange"
          onClick={() => {
            setEditCard(null);
            setShowCardModal(true);
          }}
        >
          Add New
        </button>
      </div>
    </Modal>
  );
};
export default CardListPopup;
